import classnames from 'classnames';
import { Form, FormGroup, Row, Col, Button, FormFeedback } from 'reactstrap';
import InputPasswordToggle from '@components/input-password-toggle';
import { usePasswordTabContentForm } from './usePasswordTabContentForm';

export const PasswordTabContent = () => {
  const { errors, onSubmit, register } = usePasswordTabContentForm();

  return (
    <Form onSubmit={onSubmit}>
      <Row>
        <Col sm="6">
          <FormGroup>
            <InputPasswordToggle
              label="Senha atual"
              htmlFor="currentPassword"
              name="currentPassword"
              innerRef={register({ required: true })}
              className={classnames('input-group-merge', {
                'is-invalid': errors.currentPassword,
              })}
            />
            {errors && errors.currentPassword && (
              <FormFeedback>{errors.currentPassword.message}</FormFeedback>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <InputPasswordToggle
              label="Nova Senha"
              htmlFor="newPassword"
              name="newPassword"
              innerRef={register({ required: true })}
              className={classnames('input-group-merge', {
                'is-invalid': errors.newPassword,
              })}
            />
            {errors && errors.newPassword && (
              <FormFeedback>{errors.newPassword.message}</FormFeedback>
            )}
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <InputPasswordToggle
              label="Digite novamente a Nova Senha"
              htmlFor="retypeNewPassword"
              name="retypeNewPassword"
              innerRef={register({ required: true })}
              className={classnames('input-group-merge', {
                'is-invalid': errors.retypeNewPassword,
              })}
            />
            {errors && errors.retypeNewPassword && (
              <FormFeedback>{errors.retypeNewPassword.message}</FormFeedback>
            )}
          </FormGroup>
        </Col>

        <Col>
          <p className="fw-bolder">Requisitos de senha:</p>
          <ul className="pl-1 ml-25">
            <li className="mb-50">
              Mínimo de 6 caracteres - quanto mais, melhor
            </li>
            <li className="mb-50">Pelo menos um caractere minúsculo</li>
            <li>Pelo menos um número e um caractere especial</li>
          </ul>
        </Col>

        <Col className="mt-1" sm="12">
          <Button type="submit" className="mr-1" color="primary">
            Salvar mudanças
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
